import { Module } from 'vuex'
import { RootState } from '../store-types'
import { useUserHttp } from '@/core/api/users'
import { UserMembership, UserMembershipPayload } from '@/core/models/user-membership'

const state: UserMembership = new UserMembership(<UserMembershipPayload>{})

export const userMembership: Module<UserMembership, RootState> = {
    namespaced: true,
    state,
    mutations: {
        update: (state: UserMembership, payload: UserMembershipPayload) => {
            state.fill(payload)
        }
    },
    actions: {
        get: <T>(context: any, payload: { id: number, payload: any }): Promise<T> => {
            state.unset()
            return new Promise<T>((resolve, reject) => {
                useUserHttp()
                    .membership(payload.id, payload.payload)
                    .then((data: any) => {
                        const responsePayload = data.data !== undefined ? data.data : data;

                        context.commit('update', responsePayload);
                        resolve(data as T);
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        },
    },
    getters: {
        get: (state: UserMembership): UserMembership => {
            return state
        }
    }
}
